import { c as _c } from "react/compiler-runtime";
export default function Loading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="flex items-center justify-center mt-20 min-h-screen"><div className="custom-loader" /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}